import { PlusIcon } from "@xola/icons";
import { theme } from "@xola/ui-kit";
import React from "react";

interface DashboardPlaceholderItemProps {
    onClick: () => void;
}

export const DashboardPlaceholderItem = ({ onClick }: DashboardPlaceholderItemProps) => {
    return (
        <div
            className="relative cursor-pointer border-2 border-dashed border-gray hover:border-gray-dark"
            onClick={onClick}
        >
            <div
                className="absolute z-20 h-10 w-10 -translate-x-0.5 -translate-y-1/2 border-[22px] border-transparent"
                style={{ borderLeftColor: theme.colors.gray.dark }}
            >
                <div className="absolute -top-[29px] -left-11 flex h-15 w-15 items-center justify-center">
                    <PlusIcon className="text-white" size="small" />
                </div>
            </div>
        </div>
    );
};
